"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ReplicationConfiguration_1 = require("./_ReplicationConfiguration");
exports.GetBucketReplicationOutput = {
    type: "structure",
    required: [],
    members: {
        ReplicationConfiguration: {
            shape: _ReplicationConfiguration_1._ReplicationConfiguration
        }
    },
    payload: "ReplicationConfiguration"
};
//# sourceMappingURL=GetBucketReplicationOutput.js.map